export interface MmAuditorNameParts {
  lastName: string;
  firstName: string;
  middleName: string;
  confident: boolean;
}

export function normalizeSpaces(value: string | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).replace(/\s+/g, ' ').trim();
}

export function parseFullName(fullName: string | null | undefined): MmAuditorNameParts {
  const normalized = normalizeSpaces(fullName);
  const words = normalized === '' ? [] : normalized.split(' ');

  if (words.length === 0) {
    return { lastName: '', firstName: '', middleName: '', confident: true };
  }

  if (words.length === 1) {
    /** Одно слово считаем фамилией: и колонка «ФИО», и сортировка на сервере идут по фамилии */
    return { lastName: words[0], firstName: '', middleName: '', confident: true };
  }

  if (words.length === 2) {
    return { lastName: words[0], firstName: words[1], middleName: '', confident: true };
  }

  if (words.length === 3) {
    return { lastName: words[0], firstName: words[1], middleName: words[2], confident: true };
  }

  return {
    lastName: words[0],
    firstName: words[1],
    middleName: words.slice(2).join(' '),
    confident: false,
  };
}

export function joinFullName(parts: { lastName: string; firstName: string; middleName: string }): string {
  const order = [parts.lastName, parts.firstName, parts.middleName];
  const chunks: string[] = [];

  for (let i = 0; i < order.length; i += 1) {
    const chunk = normalizeSpaces(order[i]);

    if (chunk !== '') {
      chunks.push(chunk);
    }
  }

  return chunks.join(' ');
}
